import React from "react";
import { Box, Button, Popover, Typography } from "@mui/material";
import { SwapVert, Tune } from "@mui/icons-material";
import AppSelectField from "../../../lib/components/AppSelectField";

const SortFilterMenu = ({
  sortBy,
  sortOrder,
  sortByItems = [],
  onSortByChange,
  onSortOrderChange,
  hideOrder = false,
  hideSortBy = false,
  label = "Sort",
  fieldLabel = "",
  icon,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const activeSortLabel = sortByItems.find((item) => item.value === sortBy)?.label || label;
  const orderLabel = sortOrder === "asc" ? "Asc" : "Desc";
  const StartIcon = icon || (label !== "Sort" ? Tune : SwapVert);
  const selectLabel = fieldLabel || (hideOrder ? `Filter by ${label.toLowerCase()}` : "Sort by");
  const buttonCaption = hideSortBy
    ? orderLabel
    : hideOrder
      ? activeSortLabel
      : `${activeSortLabel} · ${orderLabel}`;

  return (
    <>
      <Button
        variant="outlined"
        color="secondary"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        startIcon={<StartIcon />}
        sx={{
          textTransform: "none",
          fontWeight: 600,
          borderRadius: "10px",
          px: 2,
          whiteSpace: "nowrap",
          backgroundColor: "#fff",
          borderColor: "#D1D5DB",
          color: "#374151",
          height: 40,
        }}
      >
        {label}
        <Typography component="span" variant="caption" sx={{ ml: 1, color: "#6B7280", fontWeight: 500 }}>
          {buttonCaption}
        </Typography>
      </Button>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          sx: {
            mt: 1,
            p: 2,
            width: 280,
            borderRadius: "12px",
            boxShadow: "0 8px 24px rgba(15, 23, 42, 0.12)",
          },
        }}
      >
        <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 700 }}>
          {hideSortBy ? "Sort order" : hideOrder ? `Filter by ${label.toLowerCase()}` : "Sort table"}
        </Typography>
        <Box display="flex" flexDirection="column" gap={2.5}>
          {!hideSortBy && (
            <AppSelectField
              label={selectLabel}
              value={sortBy}
              placeholder="Select field"
              onChange={(e) => onSortByChange?.(e)}
              items={sortByItems}
            />
          )}
          {!hideOrder && (
            <AppSelectField
              label="Order"
              value={sortOrder}
              placeholder="Select order"
              onChange={(e) => onSortOrderChange?.(e)}
              items={[
                { label: "Descending", value: "desc" },
                { label: "Ascending", value: "asc" },
              ]}
            />
          )}
        </Box>
      </Popover>
    </>
  );
};

export default SortFilterMenu;
